import React from "react";

import type { BoundaryComponent } from "./_context";
import { ComponentBoundaryContextProvider } from "./_context";

export interface ComponentBoundaryProps {
	component: null | undefined | BoundaryComponent;
}

export const ComponentBoundary: React.FC<React.PropsWithChildren<ComponentBoundaryProps>> = ({
	component,
	children,
}) => <ComponentBoundaryContextProvider value={component ?? undefined}>{children}</ComponentBoundaryContextProvider>;
